import { useCollapse } from 'react-collapsed';
import { X } from '@phosphor-icons/react';
import { Message } from 'src/types';
import {
  useComparingConversationsParams,
  useRelatedQuestions,
} from 'src/hooks';
import { QuestionItem } from './components/QuestionItem';
import styles from './RelatedQuestions.module.scss';
import { SVG_SIZE_M } from 'src/constants';
import { Button } from 'src/v2/commonComponents/Button';
import { useChatHistory } from 'src/hooks';
interface RelatedQuestionsProps {
  message: Message;
  title?: string;
  isStreaming?: boolean;
}

export const RelatedQuestions = ({
  message,
  isStreaming,
  title = 'Related questions',
}: RelatedQuestionsProps) => {
  const { isNinjaRetired } = useChatHistory();
  const {
    isRelatedQuestionsVisible,
    getRelatedQuestions,
    onToggleRelatedQuestionsVisibility,
  } = useRelatedQuestions();

  const { isCompareMode } = useComparingConversationsParams();
  const { getCollapseProps } = useCollapse({
    isExpanded: isRelatedQuestionsVisible(message.message_id),
  });

  const relatedQuestions = getRelatedQuestions(message?.payload);

  const handleClose = () => {
    if (!message?.message_id) {
      return;
    }

    onToggleRelatedQuestionsVisibility(message?.message_id);
  };

  if (isNinjaRetired) {
    return null;
  }

  if (!relatedQuestions || isCompareMode || isStreaming) {
    return null;
  }

  return (
    <div {...getCollapseProps()}>
      <div className={styles.root}>
        <div className={styles.header}>
          <span>{title}</span>

          <Button
            color="transparent"
            onClick={handleClose}
            className={styles.closeButton}
          >
            <X size={SVG_SIZE_M} />
          </Button>
        </div>

        <div className={styles.collapseItemsBlock}>
          {relatedQuestions.slice(0, 3).map(({ question }, index) => (
            <QuestionItem key={index} question={question} />
          ))}
        </div>
      </div>
    </div>
  );
};
